export const successToast = (toast: any, message: string) => {
  return toast({
    duration: 3000,
    isClosable: true,
    position: "bottom-left",
    status: "success",
    title: message,
  });
};

export const errorToast = (toast: any, message: string) => {
  return toast({
    duration: 3000,
    isClosable: true,
    position: "bottom-left",
    status: "error",
    title: message,
  });
};
